<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.ADS.CREATE_OR_UPDATE.SHOW"
    :handler="(data) => openEditor(data)"
  />

  <DialogComponent ref="modal" type="modal" noInnerPadding hideCloseButton>
    <div class="w-full h-full flex flex-col overflow-auto p-4 bg-slate-50">
      <div class="mobile-status-padding"></div>

      <!-- HEADER -->
      <div class="flex justify-between items-center mb-6">
        <button
          class="w-12 h-12 p-3 rounded-full bg-slate-200"
          @click="() => $refs.modal.hide()"
        >
          <ColorImg
            class="w-full h-full bg-primary -rotate-90"
            src="/images/all/arrow-up.svg"
          />
        </button>
        <h2 class="text-2xl font-semibold text-primary">
          {{ isEditing ? 'Modifier la publicité' : 'Nouvelle publicité' }}
        </h2>
        <div class="w-12"></div>
      </div>

      <!-- FORM -->
      <div class="flex-1 space-y-4">
        <!-- TITLE (hidden) -->
        <input v-model="form.title" type="hidden" />
        <!-- DESCRIPTION (hidden) -->
        <input v-model="form.description" type="hidden" />

        <!-- IMAGE UPLOADER -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-3 text-sm font-medium text-gray-700">
            Image de la publicité
          </label>
          <FileUploadWidget
          :defaultUrls="form.pictureUrl ? [form.pictureUrl] : []"
          :acceptedFiles="['image']"
          :maxFiles="1"
          maxFileSize="800ko"
          @change="onImageChange"
        />
        </div>

        <!-- TARGET URL -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">
            Lien de destination
          </label>
          <input
            v-model="form.targetUrl"
            class="inputComponent w-full"
            placeholder="https://example.com"
            type="url"
          />
        </div>
      </div>

      <!-- ACTIONS -->
      <div class="grid grid-cols-3 gap-3 mt-6 pt-4 border-t border-gray-200">
        <button
          v-if="isEditing"
          class="px-6 py-3 rounded-xl bg-red-100 text-red-600 font-medium hover:bg-red-200"
          @click="deleteAd"
        >
          Supprimer
        </button>
        <button
          :class="{ 'col-span-2': !isEditing }"
          class="px-6 py-3 rounded-xl bg-gray-200 text-gray-700 font-medium"
          @click="() => $refs.modal.hide()"
        >
          Annuler
        </button>
        <button
          class="px-6 py-3 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700"
          @click="submit"
        >
          {{ isEditing ? 'Mettre à jour' : 'Créer' }}
        </button>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
export default {
  name: 'AdEditor',

  data() {
    return {
      isEditing: false,
      form: {
        id: null,
        title: '',
        description: '',
        pictureUrl: '',
        targetUrl: ''
      }
    };
  },

  methods: {
    openEditor(ad) {
      if (ad) {
        this.isEditing = true;
        this.form = {
          id: ad.id,
          title: ad.title || '',
          description: ad.description || '',
          pictureUrl: ad.pictureUrl || '',
          targetUrl: ad.targetUrl || ''
        };
      } else {
        this.isEditing = false;
        this.form = {
          id: null,
          title: '',
          description: '',
          pictureUrl: '',
          targetUrl: ''
        };
      }
      this.$refs.modal.show();
    },

    onImageChange(url) {
      this.form.pictureUrl = url;
    },

    submit() {
      const payload = this.isEditing
        ? { ...this.form, action: 'update' }
        : { ...this.form, action: 'create' };

      this.$bus.emit(this.$constants.EVENTS.ADS.SUBMIT, payload);
      this.$refs.modal.hide();
    },

    deleteAd() {
      if (confirm('Êtes-vous sûr de vouloir supprimer cette publicité ?')) {
        this.$bus.emit(this.$constants.EVENTS.ADS.DELETE, this.form);
        this.$refs.modal.hide();
      }
    }
  }
};
</script>
